import { from, isObservable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import Maybe from './maybe';

/**
 * An rxjs-compatible map operator for Maybes
 * Similar to `maybe.map` but for Observables.
 *
 * Takes a function that is given a value (if present) and returns an Observable or value
 * and always returns an Observable of a Maybe
 *
 * The given mapFn is *not* executed if the Maybe in the piped Observable is Nothing
 *
 * @param fn -
 */
export default function maybeSwitchMap(mapFn) {
  return function (source) {
    return source.pipe(switchMap(function (maybeItem) {
      if (maybeItem.isNothing) {
        return of(Maybe.nothing());
      }
      var result = mapFn(maybeItem.value);
      var result$ = isObservable(result) ? from(result) : of(result);
      var maybe$ = result$.pipe(map(Maybe.just));
      return maybe$;
    }));
  };
}
